"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = void 0;
var readFile = exports.readFile = function readFile(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e) {
    return callback(e.target.result);
  };
  reader.readAsDataURL(file);
};